import { call, put, delay } from "redux-saga/effects";
import { balanceApi, userApi } from "@services/api";
import { addBalanceActions } from "../slices";
import { getProfileActions } from "@redux/modules/user/slices";
import { showSuccessToast, showFailureToast } from "@helpers";

function* addBalanceWorker({ payload }) {
  yield delay(300);
  try {
    yield put(addBalanceActions.pending());
    const response = yield call(balanceApi.addBalance, payload.data);
    yield put(addBalanceActions.success(response));

    yield put(getProfileActions.pending());
    const responseGet = yield call(userApi.getProfile);
    yield put(getProfileActions.success(responseGet));

    showSuccessToast(`Added ${response.data.addedValue}$ successful!`);

    payload.resetForm();
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(addBalanceActions.failure(error));
    if (error.message) {
      showFailureToast(error.message);
    } else {
      showFailureToast("Add credits failure!");
    }
    // TODO: handle callback | onFailure
  }
}

export { addBalanceWorker };
